
export const PERMISSION_GRANTED = "PERMISSION_GRANTED"

export const PERMISSION_DENIED = "PERMISSION_DENIED"
export const POSITION_UNAVAILABLE = "POSITION_UNAVAILABLE"
export const TIMEOUT = "TIMEOUT"
export const UNKNOWN_ERROR = "UNKNOWN_ERROR"
